import { type CustomerPreviewInput, resolveEffectiveCurrency } from '@/lib/react-pdf/statement-data';

/**
 * A customer is a credit-balance account when the balance the statement would print
 * is zero or in credit. The figure is resolved through the statement's own currency
 * rules, so switching between customer and base currency can change the outcome.
 */
export function isCreditBalanceAccount(customer: CustomerPreviewInput, currencyMode?: 'customer' | 'base'): boolean {
  return resolveEffectiveCurrency(customer, currencyMode).outstanding <= 0;
}

export function partitionStatementRecipients<T extends CustomerPreviewInput>(
  customers: T[],
  excludeCreditBalanceAccounts: boolean,
  currencyMode?: 'customer' | 'base',
): { eligible: T[]; excluded: T[] } {
  if (!excludeCreditBalanceAccounts) return { eligible: customers, excluded: [] };
  const eligible: T[] = [];
  const excluded: T[] = [];
  for (const customer of customers) {
    (isCreditBalanceAccount(customer, currencyMode) ? excluded : eligible).push(customer);
  }
  return { eligible, excluded };
}
